// extracted by css-extract-rspack-plugin
export default {"MundialAddonHeader":"D7I3JrXx"};